import { useCallback } from "react";
import { CurrentWorkspaceManager } from "../useCurrentWorkspace";
import useTodo_Server from "./useTodo_Server";
import useTodoList_Server from "./useTodoList_Server";
import useWorkspace_Server from "./useWorkspace_Server";

export const useStorage_Server = (currentWorkspaceManager: CurrentWorkspaceManager) => {
    const { currentWorkspaceId } = currentWorkspaceManager;
    const { refresh: refreshWorkspace, clear: clearWorkspace, ...workspaceManager } = useWorkspace_Server();
    const { refresh: refreshTodoList, clear: clearTodoList, ...todoListManager } = useTodoList_Server(currentWorkspaceId, refreshWorkspace);
    const { refresh: refreshTodo, clear: clearTodo, ...todoManager } = useTodo_Server(currentWorkspaceId, refreshTodoList);

    const refreshAll = useCallback(async () => {
        await refreshWorkspace();
        await refreshTodoList();
        await refreshTodo();
    }, [refreshWorkspace, refreshTodoList, refreshTodo]);

    const clear = useCallback(async () => {
        await clearWorkspace();
        await clearTodoList();
        await clearTodo();
    }, [clearWorkspace, clearTodoList, clearTodo]);

    return {
        clear,
        refresh: refreshAll,
        refreshWorkspace: refreshWorkspace,
        refreshTodoList: refreshTodoList,
        refreshTodo: refreshTodo,

        //Workspace
        workspaces: workspaceManager.workspaces,
        workspaceMap: workspaceManager.workspaceMap,
        createWorkspace: workspaceManager.createWorkspace,
        deleteWorkspace: workspaceManager.deleteWorkspace,
        updateWorkspace: workspaceManager.updateWorkspace,

        //TodoList
        todoLists: todoListManager.todoLists,
        createTodoList: todoListManager.createTodoList,
        deleteTodoList: todoListManager.deleteTodoList,
        reorderList: todoListManager.reorderList,
        updateListTitle: todoListManager.updateListTitle,

        //Todo
        todos: todoManager.todos,
        todosMap: todoManager.todosMap,
        createTodo: todoManager.createTodo,
        createTodoByTodoData: todoManager.createTodoByTodoData,
        updateTodo: todoManager.updateTodo,
        deleteTodo: todoManager.deleteTodo,
        toggleTodo: todoManager.toggleTodo,
        moveTodoToList: todoManager.moveTodoToList,
    }
}

export default useStorage_Server;